import React, { useContext } from "react"
import { useFormContext } from "react-hook-form"

import Heading from "src/components/Heading"

import FormSection from "./FormSection"
import { ItemFormContext } from "./ItemFormContainer"
import TaxableTag from "./TaxableTag"

// Boat storage has no rate field of its own on the legacy path — its tax comes
// from the marina's settings — so the tag has nowhere to sit beside. Every other
// type carries it under the rate in Price, and the itemized path carries it in
// Taxes.
const StorageTax = () => {
  const { useNewTaxExperience } = useContext(ItemFormContext)
  const { watch } = useFormContext()

  if (useNewTaxExperience || watch("type") !== "boat_storage") return null

  return (
    <FormSection>
      <Heading.SectionHeader>Tax</Heading.SectionHeader>
      <p className="text-sm text-gray-600">
        Tax for storage items comes from this marina&apos;s settings.
      </p>
      <TaxableTag taxRate={0} taxRateDisplay="0%" />
    </FormSection>
  )
}

export default StorageTax
